import type { ExtensionColumnConfiguration, TableColumns } from '@/vantage/types/TableConfig.types';
import _ from 'lodash';
import type { FilterModel } from 'ag-grid-community';

const setTypeFilterModel = (filterValues: string[] | string) => {
  return { filterType: 'set', values: filterValues instanceof Array ? filterValues : [filterValues] };
};

const textTypeFilterModel = (filterValue: string[] | string) => {
  if (Array.isArray(filterValue)) {
    return {
      filterType: 'text',
      operator: 'OR',
      conditions: filterValue.map((value) => ({ filterType: 'text', filter: value, type: 'contains' })),
    };
  } else {
    return {
      filterType: 'text',
      filter: filterValue,
      type: 'contains',
    };
  }
};

const emptyDefaultFilter = (config: { meta: ExtensionColumnConfiguration }) => {
  return (
    config.meta.colDefDefaultFilter === null ||
    config.meta.colDefDefaultFilter === undefined ||
    (Array.isArray(config.meta.colDefDefaultFilter) && config.meta.colDefDefaultFilter.length === 0) ||
    config.meta.colDefDefaultFilter === ''
  );
};

export const filterModels = (columns: TableColumns) => {
  const filterModel: FilterModel = {};
  _.forIn(columns.extensions, (config: { meta: ExtensionColumnConfiguration }) => {
    setTypeFilterModel(config.meta.colDefDefaultFilter!);
    if (config.meta.colDefFilterType === 'set' && !emptyDefaultFilter(config)) {
      filterModel[config.meta.colDefName!] = setTypeFilterModel(config.meta.colDefDefaultFilter!);
    } else if (config.meta.colDefFilterType === 'text' && !emptyDefaultFilter(config)) {
      filterModel[config.meta.colDefName!] = textTypeFilterModel(config.meta.colDefDefaultFilter!);
    }
  });
  return filterModel;
};

export function quickFilterParser(quickFilter: string) {
  const quickFilterParts = [];
  let lastSpaceIndex = -1;

  const isQuote = (index: number) => quickFilter[index] === '"';
  const getQuickFilterPart = (lastSpaceIndex: number, currentIndex: number) => {
    const startsWithQuote = isQuote(lastSpaceIndex + 1);
    const endsWithQuote = isQuote(currentIndex - 1);
    const startIndex = startsWithQuote && endsWithQuote ? lastSpaceIndex + 2 : lastSpaceIndex + 1;
    const endIndex = startsWithQuote && endsWithQuote ? currentIndex - 1 : currentIndex;
    return quickFilter.slice(startIndex, endIndex);
  };

  for (let i = 0; i < quickFilter.length; i++) {
    const char = quickFilter[i];
    if (char === ' ') {
      if (!isQuote(lastSpaceIndex + 1) || isQuote(i - 1)) {
        quickFilterParts.push(getQuickFilterPart(lastSpaceIndex, i));
        lastSpaceIndex = i;
      }
    }
  }
  if (lastSpaceIndex !== quickFilter.length - 1) {
    quickFilterParts.push(getQuickFilterPart(lastSpaceIndex, quickFilter.length));
  }

  return quickFilterParts;
}
